import { apiRequest } from "../../apiCall";



class tenantMemberService {

    /**
   * Post Tenant Member Invitation
   * @returns
   */
    async postTenantMemberInvitation(memberId: string): Promise<any> {
        try {
            const response = await apiRequest("TeamMember.SendTenantMemberInvitationEmail", { tenantMemberId: memberId }, "");
            return response
        } catch (error: any) {
            throw error
        }


    }


    /**
* Get Tenant Member Detail For Delete Or Toggle
* @returns
*/
    async getTenantMemberDetailForDeleteOrToggleService(memberId: string): Promise<any> {
        try {
            const response = await apiRequest("TeamMember.GetTenantMemberDetailForDeleteOrToggle", {}, `?tenantMemberId=${memberId}`);
            return response
        } catch (error: any) {
            throw error
        }


    }


    /**
* Delete Tenant Member
* @returns
*/
    async getTenantMembers(params: any): Promise<any> {
        try {
            const response = await apiRequest("TeamMember.GetMembers", { ...params.bodyParams });//, `?ownerUserId=${params.userId}`);
            return response
        } catch (error: any) {
            throw error
        }


    }


    /**
*  
* @returns
*/
    async isTenantMemberPreviousSipExtensionAvailableService(memberId: string): Promise<any> {
        try {
            const response = await apiRequest("TeamMember.IsTenantMemberPreviousSipExtensionAvailable", {}, `?tenantMemberId=${memberId}`);
            return response
        } catch (error: any) {
            throw error
        }


    }

    /**
*  
* @returns
*/
    async getAvailableInternalPhoneService(): Promise<any> {
        try {
            const response = await apiRequest("TeamMember.GetAvailableInternalPhone", {});
            return response
        } catch (error: any) {
            throw error
        }


    }

    /**
*  
* @returns
*/
    async postToggleTenantMemberStatusService(params: any): Promise<any> {
        try {
            const response = await apiRequest("TeamMember.ToggleTenantMemberStatus", { ...params });
            return response
        } catch (error: any) {
            throw error
        }


    }

    async getActiveTenantMemberList(): Promise<any> {
        try {
            const response = await apiRequest("TenantMember.GetActiveTenantMemberList", {});
            return response
        } catch (error: any) {
            throw error
        }


    }

}

export default new tenantMemberService();